const { Number } = require('../../Number/Number')

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

/**
 * Véletlenszerű, értelmetlen szó generálása.
 * @param   {number} len           - Szó hossza.
 * @param   {string} [chars=CHARS] - Az opcionális karakterlista.
 * @returns {string}               Kapott szó.
 */
module.exports.getRandomLetters = function getRandomLetters (len, chars = CHARS) {
  const tmp = []

  for (let i = 0; i < len; i++) {
    tmp.push(chars[Number.random(0, chars.length - 1)])
  }

  return tmp.join('')
}
